export default {
  confirmTransfer:
    'Please confirm if you would like to transfer the requests on <strong>{0}</strong> to other available vehicles. If you also choose to cancel the route for the date, any unresolved requests will be canceled.',
  keepTheRoute: 'Keep the Route and Transfer the Requests',
  cancelTheRoute: 'Cancel the Route and Transfer the Requests',
  requestsTransferred: 'Requests Transferred',
  requestTransferred: 'Request Transferred',
  requestsTransferredText: 'The requests have been successfully transferred to the available vehicles.',
  requestTransferredText: 'The request have been successfully transferred to the available vehicles.',
  transferSummary: 'Transfer Summary',
  unresolvedText:
    'The optimization has been able to transfer <strong>{0}</strong> of <strong>{1}</strong> requests to other vehicles. The following requests could not be accommodated. {2}',
  cancelUnresolved: 'Cancel the Unresolved Request',
  cancelRouteAlert:
    'Please confirm if you would like to <strong>cancel</strong><br/><strong>{0}</strong> for the <strong>{1}</strong>',
  cancelRouteAlertWithOptions:
    'Please confirm if you would like to cancel<br/><strong>{0}</strong> for the <strong>{1}</strong> after selecting an option for the requests on the route.',
  tryTransfering: 'Try transferring the requests to other available vehicles and cancel any unresolved ones',
  cancelAllRequests: 'Cancel all the requests',
  routeCancelled: 'Route Cancelled',
  routeCancelledText: 'The route and the requests on it have been canceled.',
  routeNotCancelled: 'Route Not Cancelled',
  routeKeptText:
    'The requests were transferred or canceled as you chose, but the driver started a break or picked up a rider in the meantime, so the route stays in service. You can cancel it once the break or the ride is over.',
  routeNotCancelledText: 'The route could not be cancelled. Check the route on the refreshed page.',
  confirmAssignVehicle:
    'Please confirm if you want to assign vehicle <strong>{0}</strong> in place of <strong>{1}</strong>',
  changeDriver: 'Please confirm if you want to assign driver <strong>{0}</strong> in place of <strong>{1}</strong>.',
  noOrderOrRequests: {
    title: 'Cannot transfer the requests.',
    content: 'No orders or requests found.',
  },
  confirmTransferSingleRequest:
    'Please confirm if you would like to transfer the request by <strong>{riderName}</strong> on <strong>{date}</strong> with a pickup time at <strong>{pickupTime}</strong> from <strong>{routeName}</strong> to other available vehicles.',
  transferSingle: 'Transfer Request',
  cancelSingleRequest:
    'Do you want to cancel the request by <strong>{riderName}</strong> on <strong>{date}</strong> with a pickup time at <strong>{pickupTime}</strong> from <strong>{routeName}</strong>?',
  checkingRequest: 'We’re checking if the requests can be reassigned to other vehicles…',
  requestNotBeAccommodated: 'The request could not be accommodated.',
  reactivateRouteAlert: 'Please confirm if you would like to activate <strong> {0} </strong>',
  routeReactivated: 'Route Reactivated',
  routeReactivatedText: 'The route has been successfully reactivated.',
  deleteThisDayOnly: 'Delete this assignment only',
  deleteAllDays: 'Delete this and future assignments',
  updateThisDayOnly: 'Update This Day Only',
  updateAllDays: 'Update All Days',
  reservationDeleteConfirmation:
    'This reservation is valid for {days} from {startDay} to {endDay}. Do you want to delete only the selected days or all days in this reservation?',
  driverBreakRequests: 'Driver Break Requests',
  deleteDriverBreak:
    'Do you want to delete the break for <strong>{driverName}</strong> on <strong>{date}</strong> starting at <strong>{startTime}</strong>?',
  driverBreakNotFound: 'Break details could not be found. Please refresh the page and try again.',
  requestedPickupTime: 'Requested Pickup Time',
  pickupStop: 'Pick-up Location',
  dropoffStop: 'Drop-off Location',
  confirmation: 'Confirmation',
  offeredPickupTime: 'Offered Pick-up Time',
  offeredDropoffTime: 'Offered Drop-off Time',
  driverPlannedActualDropoff: 'Driver Planned / Actual Drop-off Time',
  plannedActualDropoffTime: 'Planned / Actual Dropoff Time',
  flexiRideSharedTracking: '{0} Tracking',
  cancelRoute: 'Cancel Route',
  transferRequests: 'Transfer Requests',
  activateRoute: 'Activate Route',
  multipleDrivers: 'Multiple Drivers',
  flexiRideSharedRequests: '{0} Requests',
  newFlexiRideSharedRequests: 'New {0} Request',
  confirmPhone:
    '{0} will be saved to your profile so that drivers can contact you when needed. A code will be sent via text message to verify your number.',
  confirmNumber: 'Confirm Number',
  verifyPhone: {
    verificationCodeTitle: 'Verification Code ✉️',
    pleaseEnterCode: 'Please enter the verification code sent to the phone number:',
    wrongNumber: 'Wrong number?',
    verificationCode: 'Verification code',
    wrongCode: 'Wrong verification code!',
  },
  noSafeRideRequest: 'You have no {0} requests for the selected period.',
  updateRequestWarning:
    "Updating the rider's(s) request will cancel the rider(s) original reservation and create a new request. Please confirm that you would like to continue with this updated request.",
  updateRequestWarningRider:
    "Updating your request will cancel your original reservation and create a new request. Please confirm that you'd like to continue with this updated request.",
  blacklistedByRider: 'Blacklisted by {riderNames}',
  driverBlacklistedSelectionBlocked:
    'This driver cannot be assigned because they are on the excluded drivers list for {riderNames}.',
};
